// region locale currency formatting

const currencyFormatter = Intl.NumberFormat([], {
  style: "currency",
  currency: window.c_ActiveCurrency,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function currencyFormat(value: number) {
  return currencyFormatter.format(value);
}

function formatRangePolyfill(minVal: number, maxVal: number, formatter: Intl.NumberFormat) {
  const minValString = formatter.format(minVal);
  const maxValString = formatter.format(maxVal);

  // Careful: this is a long dash (\u2013)
  return `${minValString} – ${maxValString}`;
}

// WARNING: formatRange is not defined in some typescript versions newer than '5.4.5'
// So be careful when updating typescript
export function currencyFormatRange(minVal: number, maxVal: number) {
  if (typeof currencyFormatter.formatRange === "function") {
    return currencyFormatter.formatRange(minVal, maxVal);
  } else {
    return formatRangePolyfill(minVal, maxVal, currencyFormatter);
  }
}

export const currencyUnit =
  currencyFormatter.formatToParts(42).find((part) => part.type === "currency")?.value || window.c_ActiveCurrency;

// endregion locale currency formatting

// region metric unit formatting

const unitFormatter = Intl.NumberFormat([], {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  style: "unit",
  unit: "gram",
});

export function unitFormat(value: number) {
  return unitFormatter.format(value);
}

// WARNING: formatRange is not defined in some typescript versions newer than '5.4.5'
// So be careful when updating typescript
export function unitFormatRange(minVal: number, maxVal: number) {
  if (typeof unitFormatter.formatRange === "function") {
    return unitFormatter.formatRange(minVal, maxVal);
  } else {
    return formatRangePolyfill(minVal, maxVal, unitFormatter);
  }
}

// endregion metric unit formatting

// region percent formatting

const percentFormatter = Intl.NumberFormat([], {style: "percent"});

export function percentFormat(percent) {
  return percentFormatter.format(percent / 100);
}

// endregion percent formatting
